import { createSelector } from 'reselect';
import { IAppState, LockItem } from '../types/state.d';

export type Locks = {
  charity?: boolean;
  campaign?: boolean;
  event?: boolean;
};

export const locksSelector = (state: IAppState) =>
  (state.teamlocks && state.teamlocks.locks) || [];

export const getLocks = createSelector(locksSelector, locks =>
  locks.reduce(
    (obj: Locks, lock: LockItem) => ({
      ...obj,
      [lock.type]: true,
    }),
    {},
  ),
);

export const getLocksConfigurableSelector = (state: IAppState) =>
  (state.teamlocks && state.teamlocks.configurable) || [];
